import React from 'react';
import { Delete as DeleteIcon } from '@mui/icons-material';
import Text from '../../../components/Text.js';
import * as Theme from '../../../theme/index.js';
import { styled } from '@mui/system';
import i18n from '../../../localization/i18n.js';
import tokens from '../../../localization/tokens.js';
const CardBlock = styled("div")(({
  theme
}) => ({
  display: 'flex',
  flexDirection: 'row',
  flex: 1,
  alignItems: 'center',
  '&:hover': {
    borderLeft: `${theme.palette.primary.main} solid 5px`
  },
  backgroundColor: Theme.colors.surface,
  borderLeft: `${Theme.colors.surface} solid 5px`,
  boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
  cursor: 'pointer',
  height: 'auto',
  padding: 10,
  position: 'relative'
}));

/**
 * @param data
 * @param remove
 * @param edit
 * @param isAuthorityView
 * @param classes
 * @returns {*}
 * @constructor
 */
const ExistingCoverageBlock = ({
  data,
  remove,
  edit,
  isAuthorityView,
  classes
}) => {
  const styles = {
    cardRow: {
      display: 'flex',
      flex: 1,
      flexDirection: 'row'
    },
    btnGroup: {
      display: 'flex',
      flexDirection: 'row'
    },
    section: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column'
    }
  };
  return /*#__PURE__*/React.createElement(CardBlock, null, /*#__PURE__*/React.createElement("div", {
    style: styles.cardRow,
    onClick: edit
  }, /*#__PURE__*/React.createElement("div", {
    style: styles.section
  }, /*#__PURE__*/React.createElement(Text, {
    tiny: true
  }, i18n.t(tokens.labels.masterApplication.nameOfInsurerCarrier)), /*#__PURE__*/React.createElement(Text, {
    small: true
  }, data.carrier)), /*#__PURE__*/React.createElement("div", {
    style: styles.section
  }, /*#__PURE__*/React.createElement(Text, {
    tiny: true
  }, i18n.t(tokens.labels.masterApplication.benefitsCovered)), /*#__PURE__*/React.createElement(Text, {
    small: true
  }, data.benefits.join(', ')))), !isAuthorityView && /*#__PURE__*/React.createElement(DeleteIcon, {
    onClick: remove
  }));
};
export default ExistingCoverageBlock;